import { update_address_card } from './registration';

$(document).on('click', '.editpermissionsbutton', function(evt) {
  evt.preventDefault();
  $('#edit_permissions_modal').load($(this).data('modal-path'));
});

$(function() {
  var addressCard = $('div#address_card[data-address-card-url]');
  if (addressCard.length) {
    update_address_card(addressCard);
  }
});

// Listen for validation document changes from the Validation Documents modal
document.addEventListener('validation-documents:updated', function(event) {
  var userId = event.detail && event.detail.userId;
  if (!userId) return;

  if (typeof window.update_user_with_id === 'function') {
    window.update_user_with_id(userId);
  }
  if (typeof window.refresh_address_card === 'function') {
    window.refresh_address_card();
  }
});

$(document).on('click', '.status-link-with-date', function(evt) {
  evt.preventDefault();
  var dateValue = $('#qa-date-picker').val();
  var userId = $(this).data('user-id');
  var status = $(this).data('status');
  
  if (!dateValue) {
    alert('Please select a date first');
    return;
  }
  
  // Build the URL with just the user ID in the path
  var url = '/admin/users/' + userId + '/set_user_status';
  
  // Make the AJAX call with POST method and body params
  $.ajax({
    url: url,
    method: 'POST',
    dataType: 'json',
    headers: {
      'Accept': 'text/javascript'
    },
    data: {
      status: status,
      start_at: dateValue
    }
  });
});
